export default __webpack_public_path__ + "457e682ba59c6cabdd89e066de6e0408.svg";